<template>
  <div class="m-1">
    <!-- Stats Cards Row -->
    <b-row class="mb-3">
      <!-- Recommended Leads -->
      <b-col cols="6" md="3" class="mb-3 mb-md-0">
        <div class="rounded p-2 h-100 cursor-pointer" style="background-color: #e6f7fa">
        <b-row class="d-flex align-items-center h-100">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">RECOMMENDED LEADS</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">
                  For You
                </h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ stats.recommendedLeads || 0 }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <feather-icon icon="StarIcon" size="50" class="text-primary" />
            </h2>
          </b-col>
        </b-row>
        </div>
      </b-col>

      <!-- Remaining Leads This Month -->
      <b-col cols="6" md="3" class="mb-3 mb-md-0">
        <div class="rounded p-2 h-100 cursor-pointer" style="background-color: #e6f3f7">
        <b-row class="d-flex align-items-center h-100">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">REMAINING LEADS</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">
                  This Month
                </h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ stats.remainingLeads || 0 }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <feather-icon icon="CalendarIcon" size="50" class="text-success" />
            </h2>
          </b-col>
        </b-row>
        </div>
      </b-col>

      <!-- Today's Calls -->
      <b-col cols="6" md="3" class="mb-3 mb-md-0">
        <div class="rounded p-2 h-100 cursor-pointer" style="background-color: #e8f4f8">
        <b-row class="d-flex align-items-center h-100">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">TODAY'S CALLS</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">
                  Made
                </h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ stats.todaysCalls || 0 }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <feather-icon icon="PhoneIcon" size="50" class="text-info" />
            </h2>
          </b-col>
        </b-row>
        </div>
      </b-col>

      <!-- Conversion Rate -->
      <b-col cols="6" md="3">
        <div class="rounded p-2 h-100 cursor-pointer" style="background-color: #f0e6f5">
        <b-row class="d-flex align-items-center h-100">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">CONVERSION</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">
                  Rate
                </h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ stats.conversionRate || 0 }}%</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <feather-icon icon="TrendingUpIcon" size="50" class="text-warning" />
            </h2>
          </b-col>
        </b-row>
        </div>
      </b-col>
    </b-row>

    <!-- Today's Recommended Leads Table -->
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <b-card-header class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="font-weight-bolder text-dark mb-0">
              <feather-icon icon="StarIcon" size="20" class="mr-1 text-primary" />
              Today's Recommended Leads
            </h4>
            <b-button 
              variant="primary" 
              size="sm"
              @click="showAllLeads"
            >
              <feather-icon icon="ListIcon" size="16" class="mr-1" />
              View All Leads
            </b-button>
          </b-card-header>
          <b-card-body>
            <b-table
              :items="todaysRecommendedLeads"
              :fields="leadsFields"
              :busy="isLoading"
              responsive
              hover
              striped
              show-empty
              empty-text="No recommended leads for today"
            >
              <template #cell(status)="data">
                <b-badge :variant="getStatusVariant(data.value)">
                  {{ data.value }}
                </b-badge>
              </template>
              <template #cell(created_at)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(actions)="data">
                <div class="d-flex gap-1">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="viewLeadDetails(data.item)"
                    v-b-tooltip.hover
                    title="View Details"
                  >
                    <feather-icon icon="EyeIcon" size="14" />
                  </b-button>
                  <b-button
                    variant="outline-success"
                    size="sm"
                    :href="'tel:' + data.item.phone"
                    v-b-tooltip.hover
                    title="Call Now"
                  >
                    <feather-icon icon="PhoneIcon" size="14" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Customers Section -->
    <b-row class="mt-1">
      <b-col>
        <b-card>
          <b-card-header class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="font-weight-bolder text-dark mb-0">
              <feather-icon icon="UsersIcon" size="20" class="mr-1 text-success" />
              Customers
            </h4>
            <div class="d-flex gap-5">
              <input
                ref="customerBulkUploadInput"
                type="file"
                accept=".csv,.xlsx,.xls"
                class="d-none"
                @change="handleCustomerBulkUpload"
              />
              <b-button
                variant="outline-info"
                size="sm"
                class="mr-1"
                @click="downloadSampleCsvHandler"
              >
                <feather-icon icon="DownloadIcon" size="16" class="mr-1" />
                Sample CSV
              </b-button>
              <b-button
                variant="outline-primary"
                size="sm"
                class="mr-1"
                @click="$refs.customerBulkUploadInput.click()"
              >
                <feather-icon icon="UploadIcon" size="16" class="mr-1" />
                Bulk Upload
              </b-button>
              <b-button 
                variant="primary" 
                size="sm"
                @click="showAllCustomers"
              >
                <feather-icon icon="ListIcon" size="16" class="mr-1" />
                View All Customers
              </b-button>
            </div>
          </b-card-header>
          <b-card-body>
            <b-table
              :items="latestCustomers"
              :fields="customerFields"
              :busy="isLoading"
              responsive
              hover
              striped
              small
              show-empty
              empty-text="No customers found"
            >
              <template #cell(phone)="data">
                {{ data.value || '-' }}
              </template>
              <template #cell(email)="data">
                {{ data.value || '-' }}
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Monthly Performance Chart -->
    <b-row class="mt-1">
      <b-col md="6">
        <b-card>
          <b-card-header class="mb-2">
            <h4 class="font-weight-bolder text-dark mb-0">
              <feather-icon icon="BarChartIcon" size="20" class="mr-1 text-primary" />
              Monthly Performance
            </h4>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col md="6" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>Calls Made</span>
                  <strong>{{ monthlyStats.callsMade || 0 }}</strong>
                </div>
                <b-progress :value="monthlyStats.callsMade" :max="monthlyStats.targetCalls" variant="primary" height="1.5rem"></b-progress>
              </b-col>
              <b-col md="6" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>Leads Closed</span>
                  <strong>{{ monthlyStats.leadsClosed || 0 }}</strong>
                </div>
                <b-progress :value="monthlyStats.leadsClosed" :max="monthlyStats.targetLeads" variant="success" height="1.5rem"></b-progress>
              </b-col>
              <b-col md="6" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>Follow-ups</span>
                  <strong>{{ monthlyStats.followUps || 0 }}</strong>
                </div>
                <b-progress :value="monthlyStats.followUps" :max="monthlyStats.targetFollowUps" variant="warning" height="1.5rem"></b-progress>
              </b-col>
              <b-col md="6" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>Conversion</span>
                  <strong>{{ monthlyStats.conversionRate || 0 }}%</strong>
                </div>
                <b-progress :value="monthlyStats.conversionRate" max="100" variant="info" height="1.5rem"></b-progress>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Upcoming Follow-ups -->
      <b-col md="6">
        <b-card>
          <b-card-header class="mb-2">
            <h4 class="font-weight-bolder text-dark mb-0">
              <feather-icon icon="ClockIcon" size="20" class="mr-1 text-warning" />
              Upcoming Follow-ups
            </h4>
          </b-card-header>
          <b-card-body>
            <b-list-group>
              <b-list-group-item v-for="(followup, index) in upcomingFollowups" :key="index" class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0 font-weight-bold">{{ followup.customerName }}</h6>
                  <small class="text-muted">{{ followup.phone }}</small>
                </div>
                <b-badge :variant="followup.isUrgent ? 'danger' : 'info'">
                  {{ formatTime(followup.scheduledTime) }}
                </b-badge>
              </b-list-group-item>
            </b-list-group>
            <p v-if="upcomingFollowups.length === 0" class="text-muted text-center mt-3">No upcoming follow-ups</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Lead Details Modal -->
    <b-modal
      id="lead-details-modal"
      title="Lead & Customer Details"
      size="lg"
      hide-footer
      centered
      v-if="selectedLead"
    >
      <div class="lead-detail-grid" v-if="selectedLead">
        <div class="detail-row">
          <span class="detail-label">Customer Name:</span>
          <span class="detail-value">{{ selectedLead.customerName }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Phone:</span>
          <span class="detail-value">
            <a :href="'tel:' + selectedLead.phone">{{ selectedLead.phone }}</a>
          </span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Email:</span>
          <span class="detail-value">{{ selectedLead.email }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">State:</span>
          <span class="detail-value">{{ selectedLead.state }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Status:</span>
          <span class="detail-value">
            <b-badge :variant="getStatusVariant(selectedLead.status)">
              {{ selectedLead.status }}
            </b-badge>
          </span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Interest:</span>
          <span class="detail-value">{{ selectedLead.interest }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Match Probability:</span>
          <span class="detail-value">{{ selectedLead.matchProbability }}%</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Assigned At:</span>
          <span class="detail-value">{{ selectedLead.assignedAt }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Created At:</span>
          <span class="detail-value">{{ selectedLead.created_at }}</span>
        </div>
        <div class="detail-row full-width">
          <span class="detail-label">Notes:</span>
          <span class="detail-value notes-block">{{ selectedLead.notes }}</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  computed: {
    ...mapGetters("appData", ["hasPermission"]),
  },
  data() {
    return {
      stats: {
        recommendedLeads: 0,
        remainingLeads: 0,
        todaysCalls: 0,
        conversionRate: 0
      },
      monthlyStats: {
        callsMade: 0,
        targetCalls: 100,
        leadsClosed: 0,
        targetLeads: 20,
        followUps: 0,
      },
      todaysRecommendedLeads: [],
      upcomingFollowups: [],
      latestCustomers: [],
      selectedLead: null,
      selectedCustomerFile: null,
      isLoading: false,
      leadsFields: [
        { key: "customerName", label: "Customer" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "status", label: "Status" },
        { key: "created_at", label: "Created" },
        { key: "actions", label: "Actions" }
      ],
      customerFields: [
        { key: "id", label: "ID" },
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" }
      ]
    }
  },
  mounted() {
    this.loadTodaysRecommendedLeads();
    this.loadUpcomingFollowups();
    this.loadLatestCustomers();
  },
  methods: {
    ...mapActions("appData", [
      "getLeads",
      "getCustomers",
      "bulkUploadCustomers",
      "downloadSampleCsv",
      "getAgentUpcomingFollowups"
    ]),
    async loadTodaysRecommendedLeads() {
      try {
        this.isLoading = true;
        const response = await this.getLeads();
        const results = Array.isArray(response.data) ? response.data : (response.data.results || []);
        this.todaysRecommendedLeads = results.map((lead) => ({
          id: lead.id,
          customerName: lead.customer_data ? lead.customer_data.name : "-",
          phone: lead.customer_data ? lead.customer_data.phone : "-",
          email: lead.customer_data ? lead.customer_data.email : "-",
          status: lead.status,
          interest: lead.interest || "-",
          notes: lead.notes || "-",
          matchProbability: lead.match_probability || 0,
          assignedAt: lead.assigned_at || "-",
          state: lead.state_data ? lead.state_data.name : "-",
          created_at: lead.created_at,
        }));
      } catch (error) {
        console.error("Error loading leads:", error);
        this.todaysRecommendedLeads = [];
      } finally {
        this.isLoading = false;
      }
    },

    async loadUpcomingFollowups() {
      try {
        const response = await this.getAgentUpcomingFollowups();
        if (response.status === 200) {
          this.upcomingFollowups = (response.data.results || []).map(item => ({
            customerName: item.customer_name || item.name || 'Unknown',
            phone: item.phone || item.phone_number || '',
            scheduledTime: item.assigned_date || item.last_contact_date || item.created_at,
            isUrgent: item.is_urgent || false
          }));
        }
      } catch (error) {
        console.error("Error loading upcoming follow-ups:", error);
        this.upcomingFollowups = [
          {
            customerName: 'Emily Davis',
            phone: '+1 (555) 234-5678',
            scheduledTime: moment().add(2, 'hours').toISOString(),
            isUrgent: true
          },
          {
            customerName: 'Robert Wilson',
            phone: '+1 (555) 876-5432',
            scheduledTime: moment().add(4, 'hours').toISOString(),
            isUrgent: false
          },
          {
            customerName: 'Lisa Anderson',
            phone: '+1 (555) 345-6789',
            scheduledTime: moment().add(6, 'hours').toISOString(),
            isUrgent: false
          }
        ];
      }
    },

    showAllLeads() {
      this.$router.push({ name: 'Lead' });
    },

    showAllCustomers() {
      this.$router.push({ name: 'Customer' });
    },

    async loadLatestCustomers() {
      try {
        this.isLoading = true;
        const response = await this.getCustomers({
          page: 1,
          per_page: 5,
        });
        if (response.status === 200) {
          this.latestCustomers = response.data.results || [];
        }
      } catch (error) {
        console.error("Error loading customers:", error);
        this.latestCustomers = [];
      } finally {
        this.isLoading = false;
      }
    },

    async handleCustomerBulkUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      
      event.target.value = '';
      
      const formData = new FormData();
      formData.append('file', file);
      
      try {
        const response = await this.bulkUploadCustomers(formData);
        const data = response.data;
        const errorCount = data.errors ? data.errors.length : 0;
        
        if (errorCount > 0) {
          const errorText = data.errors.map(e => `Row ${e.row}: ${e.error}`).join('\n');
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: `Created ${data.created} customers. ${errorCount} errors.`,
                text: errorText,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            },
            {
              position: "top-right",
            }
          );
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Bulk Upload Successful",
                text: `${data.created} customers created successfully.`,
                icon: "CheckCircleIcon",
                variant: "success",
              },
            },
            {
              position: "top-right",
            }
          );
        }
        await this.loadLatestCustomers();
      } catch (error) {
        const msg = error.response?.data?.detail || error.message || "Upload failed.";
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Bulk Upload Failed",
              text: msg,
              icon: "XCircleIcon",
              variant: "danger",
            },
          },
          {
            position: "top-right",
          }
        );
      }
    },

    async downloadSampleCsvHandler() {
      try {
        const response = await this.downloadSampleCsv();
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'customers_sample.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Download Started",
              text: "Sample CSV template downloaded.",
              icon: "DownloadIcon",
              variant: "info",
            },
          },
          {
            position: "top-right",
          }
        );
      } catch (error) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Download Failed",
              text: error.message || "Unable to download sample CSV.",
              icon: "XCircleIcon",
              variant: "danger",
            },
          },
          {
            position: "top-right",
          }
        );
      }
    },

    viewLeadDetails(lead) {
      this.selectedLead = lead;
      this.$bvModal.show('lead-details-modal');
    },

    formatDate(dateString) {
      return moment(dateString).format('MMM DD, YYYY HH:mm');
    },

    formatTime(dateString) {
      return moment(dateString).format('HH:mm');
    },

    getStatusVariant(status) {
      const variants = {
        'New': 'primary',
        'Contacted': 'info',
        'Qualified': 'success',
        'In Progress': 'warning',
        'Closed': 'secondary',
        'Lost': 'danger',
        'Not Interested': 'secondary'
      };
      return variants[status] || 'secondary';
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}

.cursor-pointer:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.h-100 {
  height: 100%;
  min-height: 120px;
}

.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 12px;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-bottom: 1px solid #dee2e6;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}

.badge {
  font-weight: 500;
  padding: 0.5rem 0.75rem;
}

.gap-1 {
  gap: 0.25rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
}

/* Hover effects for stat boxes */
.rounded.cursor-pointer:hover {
  background-color: rgba(0, 168, 204, 0.1) !important;
}

/* Action button hover effects */
.btn-outline-primary:hover {
  background-color: #00a8cc;
  border-color: #00a8cc;
}

.btn-outline-success:hover {
  background-color: #28a745;
  border-color: #28a745;
}

.lead-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
}
.detail-row {
  display: flex;
  flex-direction: column;
}
.detail-row.full-width {
  grid-column: 1 / -1;
}
.detail-label {
  font-weight: 600;
  color: #6c757d;
  font-size: 0.8rem;
  text-transform: uppercase;
  margin-bottom: 2px;
}
.detail-value {
  color: #212529;
  font-size: 0.95rem;
}
.detail-value.notes-block {
  white-space: pre-wrap;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 6px;
  margin-top: 4px;
}
</style>
